import Vue from 'vue';

import {
  ValidationProvider,
  ValidationObserver,
  extend,
  setInteractionMode,
} from 'vee-validate';

import {
  required,
  email,
} from 'vee-validate/dist/rules';
import { i18n } from './i18n';

setInteractionMode('eager');

// Validation rules
extend('required', {
  ...required,
  message: i18n.t('common.missingRequiredField'),
});

extend('email', email);

// Validation components
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
